<progress-bar
    progressType="absolute"
    [current]="(currentSizeInB$ | async) ?? 0 | applyPureFunction: formatFileSizeFromBytes"
    [maximum]="limitSizeInB | applyPureFunction: formatFileSizeFromBytes"
    [progress]="(progress$ | async) ?? 0"
    [color]="progressColor"
/>
@if ((isDownloadDone$ | async) !== true) {
    <div>
        <p class="info">{{ processStatusTranslation$ | async }}</p>
        @if ((isExistFile$ | async) && defaultConflictResolutionStrategy === 'NONE') {
            <div>
                <ui-table class="table" [dataSource]="(inputData$ | async) ?? []">
                    <ng-container uiColumnDef="title">
                        <ui-header-cell *uiHeaderCellDef />
                        <ui-cell *uiCellDef="let line">
                            {{ line.title }}
                        </ui-cell>
                    </ng-container>
                    <ng-container uiColumnDef="importedFileValue">
                        <ui-header-cell *uiHeaderCellDef>
                            {{ 'DOCUMENT_MANAGEMENT_SYSTEM_IMPORT.MODAL.IMPORTED_FILE' | translate }}
                        </ui-header-cell>
                        <ui-cell *uiCellDef="let line">
                            {{ line.importedFileValue }}
                        </ui-cell>
                    </ng-container>
                    <ng-container uiColumnDef="existingFileValue">
                        <ui-header-cell *uiHeaderCellDef>
                            {{ 'DOCUMENT_MANAGEMENT_SYSTEM_IMPORT.MODAL.EXISTING_FILE' | translate }}
                        </ui-header-cell>
                        <ui-cell *uiCellDef="let line">
                            {{ line.existingFileValue }}
                        </ui-cell>
                    </ng-container>
                    <ui-header-row *uiHeaderRowDef="headers" />
                    <ui-row *uiRowDef="let row; columns: headers" />
                </ui-table>
            </div>
        }
        <div [style.display]="!(isExistFile$ | async) && defaultConflictResolutionStrategy === 'NONE' ? 'none' : ''">
            <div class="actions">
                <button #skip color="primary" ui-button type="button">
                    {{ 'BUTTONS.SKIP' | translate }}
                </button>
                <button #keepBoth color="primary" ui-button type="button">
                    {{ 'BUTTONS.KEEP_BOTH' | translate }}
                </button>
                <button #replace color="primary" ui-button type="button">
                    {{ 'BUTTONS.REPLACE' | translate }}
                </button>
            </div>
            <div class="check-box">
                <ui-checkbox
                    [label]="'DOCUMENT_MANAGEMENT_SYSTEM_IMPORT.MODAL.REPEAT' | translate"
                    [ngModel]="changeDefaultConflictResolutionStrategy"
                    (ngModelChange)="toggleCheckOfRepeatConflictStrategy($event)"
                />
            </div>
        </div>
    </div>
} @else {
    <div class="info">
        <p>{{ 'DOCUMENT_MANAGEMENT_SYSTEM_IMPORT.MODAL.COMPLETED' | translate }}</p>
        <button color="primary" ui-button type="button" (click)="close.emit()">
            {{ 'BUTTONS.OK' | translate }}
        </button>
    </div>
}
